import React from 'react'
import './Style.css'
export default function TopBanner() {
  return (
    <div className="TopBanner">
        <div className="contain">
        <div className="small-bold-text banner-text">
       Welcome To Our Reactjs Ielts Website ~</div>
        </div>
    </div>
  )
}
